import { render, staticRenderFns } from "./ActualizarReglaINT.vue?vue&type=template&id=61ad9788"
import script from "./ActualizarReglaINT.vue?vue&type=script&lang=js"
export * from "./ActualizarReglaINT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports